import React from "react";
import { DestinationTypeLabels } from "../../../models/destinationType.map";
import { StatutMedicamentColors, StatutMedicamentLabels } from "../../../models/statutMedicament.map";

// Pastilles de statut et de flux, cadre de filtre libellé et message d'état vide.

export function StatusPill({ value }) {
    const colors = StatutMedicamentColors[value] || { bg: "#f1f5f9", color: "#475569" };
    return (
        <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "3px 8px",
            borderRadius: "999px",
            background: colors.bg,
            color: colors.color,
            fontSize: "11px",
            fontWeight: 700,
            lineHeight: 1.2,
            maxWidth: "100%",
            whiteSpace: "normal",
            textAlign: "center",
            boxSizing: "border-box",
        }}>
            {StatutMedicamentLabels[value] || value || "Non traité"}
        </span>
    );
}

export function DestinationBadge({ value }) {
    return (
        <span style={{
            display: "inline-flex",
            padding: "3px 8px",
            borderRadius: "6px",
            background: value === "ROBOT" ? "#eef2ff" : "#ecfeff",
            color: value === "ROBOT" ? "#4338ca" : "#0e7490",
            fontSize: "11px",
            fontWeight: 700,
        }}>
            {DestinationTypeLabels[value] || value || "Flux inconnu"}
        </span>
    );
}

export function FilterShell({ label, children }) {
    return (
        <div style={{ display: "flex", alignItems: "stretch", borderRadius: "7px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
            <span style={{ padding: "5px 10px", fontSize: "12px", fontWeight: 600, color: "#64748b", background: "#f8fafc", borderRight: "1px solid #e2e8f0", display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                {label}
            </span>
            {children}
        </div>
    );
}

export function EmptyState({ children }) {
    return <div style={{ padding: "48px", textAlign: "center", color: "#94a3b8", fontSize: "14px" }}>{children}</div>;
}
